import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useTranslation} from "react-i18next";
import {WarningAmberRounded} from "@mui/icons-material";
import {useNavigate} from 'react-router-dom';

const NotAllowedDialog = (props: any) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const handleClose = () => {
        !!props.handleClose ? props.handleClose() : navigate("/");
    };

    return (
        <Dialog
            open={props.open !== undefined ? props.open : true}
            onClose={() => {
            }}
            aria-labelledby="responsive-dialog-title"
            disableEscapeKeyDown={true}
        >
            <DialogTitle id="responsive-dialog-title" sx={{display: 'flex', justifyContent: 'center'}}>
                {props.title}
                <WarningAmberRounded color={'error'}/>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {!!props.buttonLabel ? props.buttonLabel : t('info.ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NotAllowedDialog;